import context from '@/services/ctx'
import { trelloStore, StoreScope, StoreType } from '@/services/trellostore';
import Icons from '@/icons'
import StoreKeys from '@/services/storekeys'
import channel from '@/cqs/channel';
import * as queries from  '@/cqs/queries'
import '@/lib/extensions';
import {getDataForCardFront, getStorymapProperties, getDataForCardBack, isCardLinked, checkAccess} from '@/services/storiesonboardrepository';
import { CardData } from '@/cqs/remotequeries';
import { Dictionary } from 'typescript-collections';


class EstimationModule implements ICardBadgesProvider, ICardDetailsBadgesProvider,ICardListSortersProvider {

    public async getListSorters(t: ITrelloClient, opts: any): Promise<any[]> {
        var result = [];

        var getCards = async () => {
            const list = await t.list('all');
            var cardDataMap = new Dictionary<string, CardData>();
            var hasAccess = await checkAccess(t);
            if(hasAccess) {
                var cardDataTasks: Promise<CardData>[] = list.cards.select(card => getDataForCardFront(t, card.id));
                var cardDatas = await Promise.all(cardDataTasks);
                cardDatas.forEach(card => {
                    if(card != null) {
                        cardDataMap.setValue(card.Id, card);
                    }
                });
            }
            var cards = [];
            list.cards.forEach(card => {
                var cardData = cardDataMap.containsKey(card.id)
                    ? cardDataMap.getValue(card.id)
                    : null;
                cards.push({ id: card.id, estimation: cardData?.Estimation });
            });
            return cards;
        }

        result = [
            {
                text: "Estimation (0 -> 9)",
                callback: async (t, opts) => {
                    var cards = await getCards();
                    var sortedCards = cards.sort(function(a,b) {
                        if(a.estimation == null){
                            return 1;
                        }
                        else if(b.estimation == null){
                            return -1;
                        }
                        else if (a.estimation > b.estimation) {
                            return 1;
                        } 
                        else if (b.estimation > a.estimation) {
                            return -1;
                        }
                        return 0;
                    });
                    return {
                        sortedIds: sortedCards.map(function (c) { return c.id; })
                    };
                }
            },
            {
                text: "Estimation (9 -> 0)",
                callback: async (t, opts) => {
                    var cards = await getCards();
                    var sortedCards = cards.sort(function(a,b) {
                        if(a.estimation == null){
                            return 1;
                        }
                        else if(b.estimation == null){
                            return -1;
                        }
                        else if (a.estimation < b.estimation) {
                            return 1;
                        } 
                        else if (b.estimation < a.estimation) {
                            return -1;
                        }
                        return 0;
                    });
                    return {
                        sortedIds: sortedCards.map(function (c) { return c.id; })
                    };
                }
            }
        ];

        return result;
    }


    public getCardBadges(t: ITrelloClient, opts:any) : Promise<Array<any>> {
        return this.createBadges(true, t, opts, estimation => {
            return {
                text: estimation + ' pts',
                icon: Icons.Estimation.BadgeIcon,
            }
        });
    }


    public getCardDetailsBadges = async(t: ITrelloClient, opts:any) : Promise<Array<any>> => {
        var badges = await this.createBadges(false, t, opts, estimation => {
            return {
                title: "Estimation",
                text: estimation                
            };
        });

        var ctx = await context(t).get();
        const hasAccess = await checkAccess(t);
        if(ctx.config.isEnableEditEstimation && hasAccess) {
            var storymapProps = await getStorymapProperties(t);
            if(storymapProps.canSetEstimation && badges.length == 1) {
                badges[0].callback = (t) => {
                    return t.popup({
                        title: 'Estimate card (story points)',
                        url: './views/estimate.html',
                        args: { },
                        });
                }
            }
        }

        return badges;
    }

    private async createBadges(isFront: boolean, t: ITrelloClient, opts:any, badgeFactory: (estimation: number) => any) : Promise<Array<any>> {
        var badges = [];
        var hasAccess = await checkAccess(t);
        if(hasAccess) {
            var ctx = await context(t).get();
            var cfg = ctx.config;
            var showEstimation = isFront ? cfg.isShowEstimationOnCardFront : cfg.isShowEstimationOnCardBack;
            if (showEstimation){
                var card: CardData = isFront 
                ? await getDataForCardFront(t, opts.context.card)
                : await getDataForCardBack(t, opts.context.card);
                if(card != null) {
                    //await this.storeEstimation(t, card.estimation);
                    var estimation = await this.getStoredEstimation(t);
                    estimation = card.Estimation;
                    if(estimation != null) {
                        var badge : any = badgeFactory(estimation);                        
                        var bigStoryLimit = parseInt(cfg.bigStoryLimit);
                        if (cfg.isMarkBigStoryCards && (!bigStoryLimit || estimation >= bigStoryLimit)) {
                            badge.color = Icons.Estimation.BgColorLargeStory
                        }

                        badges.push(badge);
                    }
                }
            }
        } 

        return badges;
    }


    public getCardButtons = async (t: ITrelloClient, opts: any) : Promise<Array<any>> => {
        var buttons:Array<any> = [];
        var hasAccess = await checkAccess(t);
        var ctx = await context(t).get();
        if(ctx.config.isEnableEditEstimation && hasAccess) {
            var storymapProps = await getStorymapProperties(t);
            if(storymapProps.canSetEstimation) {
                var isLinked = await isCardLinked(t, t.getContext().card);
                if(isLinked) {
                    buttons.push(<never>this.estimationButton);
                }
            }
        }
        
        return buttons;
    }


    private readonly estimationButton = {
        icon: Icons.Estimation.BadgeIcon,
        text: 'Estimate',
        callback: function(t: ITrelloClient,o) {
            return t.popup({
                    title: 'Estimate card',
                    url: './views/estimate.html',
                });
        }
    }    

    private getStoredEstimation = async (t: any): Promise<number> => {
        var estimation = await trelloStore(t).getCardShared(StoreKeys.Card.Estimation);
        return estimation;
    }
}
export var estimationModule = new EstimationModule();
export default estimationModule;
